import { ReactNode, useEffect, useState } from 'react';

import bgFinal from '@/assets/tournaments/bg_final_ml.jpg';
import bgFinalWinner from '@/assets/tournaments/bg_final_ml_winner.jpg';
import bgCoverDefault from '@/assets/tournaments/bg_minileagues-cover--default@2x.jpg';
import bgPrize from '@/assets/tournaments/bg_ml-prize.png';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { EnumCoverMinileagues } from '@/types/minileagues';

interface ContextData {
  bg: string;
  bgDesktop?: string;
  title: ReactNode;
}

const DATA_CONTEXT = (
  position?: number,
  prize?: string
): Partial<Record<EnumCoverMinileagues, ContextData>> => ({
  [EnumCoverMinileagues.Prize]: {
    bg: bgPrize,
    bgDesktop: bgCoverDefault,
    title: (
      <>
        ¡Hay premios en efectivo
        <br /> para los 5 mejores!
      </>
    ),
  },
  [EnumCoverMinileagues.Consult]: {
    bg: bgPrize,
    bgDesktop: bgCoverDefault,
    title: (
      <>
        Consultá cómo terminaste
        <br /> en tu Miniliga
      </>
    ),
  },
  [EnumCoverMinileagues.PassFinal]: {
    bg: bgPrize,
    bgDesktop: bgCoverDefault,
    title: (
      <>
        Ganá tu pase a la Final y<br />
        competí por premios en efectivo
      </>
    ),
  },
  [EnumCoverMinileagues.FinalEnd]: {
    bg: bgPrize,
    bgDesktop: bgCoverDefault,
    title: (
      <>
        CONSULTÁ CÓMO TERMINASTE <br /> EN TU MINILIGA
      </>
    ),
  },
  [EnumCoverMinileagues.NoParticipate]: {
    bg: bgPrize,
    title: '',
  },
  [EnumCoverMinileagues.NotClassified]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.NotWinner]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.Classified]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.Winner]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.InProgress]: {
    bg: bgPrize,
    title: 'Miniligas',
  },
  [EnumCoverMinileagues.FinalClassified]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title:
      'ESTÁS EN LA FINAL. ¡MEJORÁ TU EQUIPO! PODÉS SER UNO DE LOS 5 GANADORES.',
  },
  [EnumCoverMinileagues.FinalPlayerNotClassified]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: 'NO CLASIFICASTE A LA FINAL. ¡CONOCÉ MUY PRONTO A LOS GANADORES!',
  },
  [EnumCoverMinileagues.FinalPlayerNotParticipating]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title:
      'NO PARTICIPASTE DE LAS MINILIGAS. ¡CONOCÉ MUY PRONTO A LOS GANADORES!',
  },
  [EnumCoverMinileagues.FinalWinner]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: '¡FELICITACIONES! ERES UNO DE LOS GANADORES DE LA FINAL.',
  },
  [EnumCoverMinileagues.FirstMale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinner,
    title: (
      <>
        ¡FELICITACIONES! SOS EL CAMPEÓN DE LA FINAL DE MINILIGAS.
        <br />
        ¡GANASTE ${prize}!
      </>
    ),
  },
  [EnumCoverMinileagues.SecondMale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinner,
    title: (
      <>
        ¡FELICITACIONES! SALISTE SEGUNDO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.ThirdMale]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ¡FELICITACIONES! SALISTE TERCERO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FourthMale]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ¡FELICITACIONES! SALISTE CUARTO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FifthMale]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ¡FELICITACIONES! SALISTE QUINTO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FirstFemale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinner,
    title: (
      <>
        ¡FELICITACIONES! SOS LA CAMPEONA DE LA FINAL DE MINILIGAS.
        <br />
        ¡GANASTE ${prize}!
      </>
    ),
  },
  [EnumCoverMinileagues.SecondFemale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinner,
    title: (
      <>
        ¡FELICITACIONES! SALISTE SEGUNDA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.ThirdFemale]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ¡FELICITACIONES! SALISTE TERCERA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FourthFemale]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ¡FELICITACIONES! SALISTE CUARTA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FifthFemale]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ¡FELICITACIONES! SALISTE QUINTA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.NoTop5]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        LAMENTABLEMENTE NO ESTÁS ENTRE LOS GANADORES.
        <br />
        ¡TE ESPERAMOS EN LA PRÓXIMA EDICIÓN!
      </>
    ),
  },
  [EnumCoverMinileagues.NotParticipatedOrNotClassified]: {
    bg: bgFinal,
    bgDesktop: bgFinal,
    title: (
      <>
        ESTOS FUERON LOS MEJORES DE LA FINAL.
        <br />
        ¡TE ESPERAMOS EN LA PRÓXIMA EDICIÓN!
      </>
    ),
  },
});

interface Props {
  context?: EnumCoverMinileagues;
  position?: number;
  prize?: string;
}

export const useBackgroundByContext = ({
  context = EnumCoverMinileagues.Prize,
  position,
  prize,
}: Props) => {
  const [state, setState] = useState<ContextData | null>(null);
  const { isMobile } = useIsDesktop();

  useEffect(() => {
    const data = DATA_CONTEXT(position, prize)[context];
    if (data) {
      setState(data);
    } else {
      setState(null);
    }
  }, [context]);

  if (!state) {
    return null;
  }

  if (isMobile) {
    return { src: state.bg, title: state.title };
  }

  return { src: state.bgDesktop, title: state.title };
};
